export default __webpack_public_path__ + "static/media/cs_icon_06.eb015823.png";